import { GridRowId } from '@mui/x-data-grid';
import SubcommitteeDeleteButton from './SubcommitteeDeleteButton';
import SubcommitteeEditButton from './SubcommitteeEditButton';

export type SubcommitteeActionsProps = {
  rowId: GridRowId;
};

const SubcommitteeActions = ({ rowId }: SubcommitteeActionsProps) => {
  return (
    <>
      <SubcommitteeEditButton rowId={rowId} />
      <SubcommitteeDeleteButton rowId={rowId} />
    </>
  );
};

export default SubcommitteeActions;
